export default __webpack_public_path__ + "static/media/background.b89eb203.png";